import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Titles", href: "/titles", current: true },
];
export default function Titles() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="titles">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}